import React from "react";
import {Dropdown} from "react-bootstrap";
import UserModal from "../../../Components/User/Stat/Modal";
import storage from "../../../../Storage";
import {defaultAvatar} from "../../../../Helper";
import PrivateMessage from "./../PrivateMessage";
import Logout from "./../../Auth/Logout";

class User extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            level: 1,
            name: storage.getKey('name'),
            phone: storage.getKey('phone'),
            avatar: storage.getKey('avatar') !== 'false' ? storage.getKey('avatar'): defaultAvatar
        };
    }
    render() {
        const { t } = this.props;
        return (
                    <Dropdown left="true">
                        <Dropdown.Toggle split variant="b btn-sm" id="dropdown-split-user">
                            <i className={"fa fa-list text-warning"}></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className={"droper user-dropdown-detail"}>
                            <UserInfo level={this.state.level} name={this.state.name} phone={this.state.phone} avatar={this.state.avatar} t={t} />
                            <div className="dropdown-divider"/>
                            <div className="user-links">
                                <Dropdown.Item as={'button'} className={"animated fadeIn"}>
                                    <a title={'Get to us on +254 20 790 0779'} href="tel:+254 20 790 0779"><i className={'fas fa-phone'}> Support</i></a>
                                </Dropdown.Item>
                                <Dropdown.Item as={'button'} className={"animated fadeIn"}>
                                    <PrivateMessage desktop={true} t={t} />
                                </Dropdown.Item>
                                <Dropdown.Item as={'button'} className={"animated fadeIn"}>
                                    <Logout t={t} />
                                </Dropdown.Item>
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
        );
    }
}

class UserInfo extends React.Component {
    makeStars = (num) => {
        let stars = 5;
        let userLevel = stars - parseFloat(num);
        var g = [], o = [], f = [];
        for(var i = 0; i < userLevel; i++){
            g.push(<i className={'mdi mdi-star font-15'} />);
        }
        for(var i = 0; i < num; i++){
            o.push(<i className={'mdi mdi-star text-success font-20'} />);
        }
        f.push(o, g);
        return f;
    }
    render(){
        const { name, level, avatar, t, phone } = this.props;
        return(
            <>
                <div className="user-bar">
                    {<UserModal phone={phone} t={t} username={name} menu={true} avatar={avatar} />}
                    <span className="text-white">{name}</span>
                    <br/>
                    <span>{this.makeStars(level)}</span>
                </div>
            </>
        );
    }
}

export default User;